import React, { createContext, useState, useContext, ReactNode } from "react";

type DiaryEntryData = {
    feeling: string | null;
    description: string | null;
    audioUrl?: string | null;
    aiResponse?: string | null;
};

interface DiaryContextType {
    diaryData: DiaryEntryData;
    updateDiaryData: (data: Partial<DiaryEntryData>) => void;
    resetDiaryData: () => void;
    isLoadingAIResponse: boolean;
    setIsLoadingAIResponse: (value: boolean) => void;
}

const DiaryContext = createContext<DiaryContextType>({
    diaryData: { feeling: null, description: null },
    updateDiaryData: () => { },
    resetDiaryData: () => { },
    isLoadingAIResponse: false,
    setIsLoadingAIResponse: () => { },
});

export const DiaryProvider = ({ children }: { children: ReactNode }) => {
    const [diaryData, setDiaryData] = useState<DiaryEntryData>({
        feeling: null,
        description: null,
        audioUrl: null,
    });
    const [isLoadingAIResponse, setIsLoadingAIResponse] = useState(false);

    const updateDiaryData = (data: Partial<DiaryEntryData>) => {
        setDiaryData((prev) => ({ ...prev, ...data }));
        setIsLoadingAIResponse(false);
    };

    const resetDiaryData = () => {
        setDiaryData({ feeling: null, description: null, audioUrl: null, aiResponse: null });
    };

    return (
        <DiaryContext.Provider value={{ diaryData, updateDiaryData, resetDiaryData, isLoadingAIResponse, setIsLoadingAIResponse }}>
            {children}
        </DiaryContext.Provider>
    );
};

export const useDiary = () => useContext(DiaryContext);
